<template>
  <div class="container">
    <div class="regard-home">
      <div class="regard-home-content regard-home-content-1">
        <div class="l-regard-view l-regard-view-1">
          <div style="background-color: #ffffff69">
            <span class="l-rv-title">一群有义有情的人在一起</span>
            <div class="l-rv-content">做一件有意义的伟大的事业</div>
          </div>
        </div>
      </div>
      <div class="video-box">
        <video
          data-v-bde1585c=""
          autoplay="autoplay"
          controls="controls"
          loop="loop"
          src="https://bopin.oss-cn-shenzhen.aliyuncs.com/video.mp4"
        ></video>
      </div>
      <div>
        <div class="container">
          <div class="regard-home-content regard-home-content-2">
            <div class="l-regard-view l-regard-view-2">
              <h3 class="l-regard-view-title">播聘人才集团简介</h3>
              <div class="l-r-v-list">
                <div class="l-r-v-item" v-for="(s, i) in intr" :key="i">
                  {{ s.title }}
                </div>
              </div>
            </div>
          </div>

          <div class="regard-home-content regard-home-content-3">
            <div class="l-regard-view l-regard-view-3">
              <div class="l-regard-content">
                <h3 class="l-rc-title">播聘集团</h3>
                <div data-v-e97f86d2="" class="l-rc-content">
                  <div
                    data-v-e97f86d2=""
                    class="l-rc-content-list l-rc-content-line"
                  >
                    <h5 data-v-e97f86d2="" class="l-rc-cl-title">愿景</h5>
                    <div data-v-e97f86d2="" class="l-rc-cl-view">
                      站在用工模式最前沿 释放每个人的价值
                    </div>
                  </div>
                  <div data-v-e97f86d2="" class="l-rc-content-list">
                    <h5 data-v-e97f86d2="" class="l-rc-cl-title">使命</h5>
                    <div data-v-e97f86d2="" class="l-rc-cl-view l-rc-cl-view-1">
                      打造诚信、高效、专业的 一站式招聘服务平台
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="regard-home-content regard-home-content-4">
            <div class="l-regard-view l-regard-view-4">
              <h3 class="l-regard-view-title">使命价值观</h3>
              <div class="l-regard-list">
                <div class="l-regard-item" v-for="(s, i) in list" :key="i">
                  <div class="l-regard-list-pad">
                    <h4 class="l-regard-item-title">{{ s.title }}</h4>
                    <h5 class="l-regard-item-sub-title">{{ s.sub_title }}</h5>
                    <div class="l-regard-item-content">
                      <div
                        class="l-regard-item-list"
                        v-for="(item, key) in s.list"
                        :key="key"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-regard-list l-regard-list-1">
                <div class="l-regard-item" v-for="(s, i) in list1" :key="i">
                  <div class="l-regard-list-pad">
                    <h4 class="l-regard-item-title">{{ s.title }}</h4>
                    <h5 class="l-regard-item-sub-title">{{ s.sub_title }}</h5>
                    <div class="l-regard-item-content">
                      <div
                        class="l-regard-item-list"
                        v-for="(item, key) in s.list"
                        :key="key"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyIntr",
  data() {
    return {
      intr: [
        {
          title:
            "播聘人才集团是一家综合性的人力资源产业集团公司，2018年成立于深圳市南山区高新园，现运营总部位于深圳市罗湖区。经过八年时间的发展，播聘人才集团目前拥有二十余家全资子公司，在全国范围内三十余家直营分公司，集团业务覆盖全国三十余省、市、自治区，成功搭建了全国统一人力资源服务网络。",
        },
        {
          title:
            " 播聘人才集团是中国人力资源行业领军企业、作为全球最早的人才市场数字化新基建的开拓者是全球5G技术人才市场的领军企业、中国著名品牌、深圳市人力资源行业协会常务理事单位、质量服务诚信3A级企业、人力资源创新大赛冠军企业，为人才流通做出了杰出贡献，目前已为两千余万求职者和六十万余家知名企业提供了高效率的人力资源服务和5G人才服务解决方案。",
        },
        {
          title:
            "播聘人才集团主要业务板块覆盖人力资源行业全产业链，包括劳务派遣、猎头业务、代理招聘人力外包、人事外包、管理咨询、软件开发外包、财务外包、影视传媒、电视节目运作、元宇宙游戏、人工智能、连锁零售、高端劳务派遣、购销汇等业务板块。为企业提供多种灵活用工解决方案为求职者提供多样化的解决方案，帮助企业和求职者实现成功。",
        },
        {
          title:
            "播聘国际控股集团高瞻远瞩，深刻认知人类文明的数字化进程，顺势而为，始终将自身发展目标定位于成为全球最大数字化人才市场的构建者。在未来，播聘人才集团将立足中国面向全球，快速构建成为全球最大的人才市场，为全球范围内不同国家、地区的企业和80亿地球居民和人才，提供跨时空、跨地域的人才服务，引领全球人才流通数字化新未来!",
        },
      ],
      list: [
        {
          title: "感恩",
          sub_title: "用户第一 心怀感恩",
          list: [
            {
              title:
                "斗米之恩，心必念之：用户第一，走近用户，充分了解用户，为用户创造 最大价值 ",
            },
            {
              title:
                "感恩公司，共同成长：具有主人翁意识，随时随地维护公司形象，在尊重 用户的前提之下，达成公司和用户利益的均衡 ",
            },
            {
              title:
                "感谢伙伴，共担共享：积极融入团队，具有开放共赢心态，善于利用团队 的力量解决问题和困难",
            },
          ],
        },
        {
          title: "正直",
          sub_title: "坚行正道 言行坦荡",
          list: [
            {
              title:
                "厚德载物，以德为先：坚持正心做事、正念为人，坚守正道，用正直的力量 积极影响我们周围的人",
            },
            {
              title: "心胸坦荡，言行一致，言出必践，直言而有讳",
            },
            {
              title:
                "公平公正，客观评价团队：主动担当，不委过于人；清正廉洁，严格遵守 职业操守",
            },
          ],
        },
      ],
      list1: [
        {
          title: "创新",
          sub_title: "打破常规 不懈探索",
          list: [
            {
              title: "创新的核心目的是为用户创造价值 ",
            },
            {
              title:
                "敏锐预见用户与市场的变化，打破常规、营造人人事事皆可创新的氛围",
            },
            {
              title: "不懈探索，敢于突破，勇于尝试，不惧失败，善于总结",
            },
          ],
        },
        {
          title: "尽责",
          sub_title: "专业执着 精益求精",
          list: [
            {
              title:
                "有强烈的使命感，成就驱动，勇于承担责任，主动迎接新的任务和挑战 ",
            },
            {
              title: "热爱公司，全身心投入，尽职尽责，极致执行，追求卓越 ",
            },
            {
              title:
                "保持好奇心，坚持钻研、持续学习、不断提高专业水平与职业能力",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped="scoped">
@import url("./company-intr.css");
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue